import { AppState } from '../models/state/appState';

/**
 * Selected the command definitions state.
 * @param state
 */
export function selectCommandDefinitions(state: AppState) {
  return state.commandDefinitions;
}
